export const CNIL = 'CNIL';
export const EMAIL_OPTIN = 'EMAIL_OPTIN';
export const SMS_OPTIN = 'SMS_OPTIN';
export const MAIL_OPTIN = 'MAIL_OPTIN';
export const PASSPORT_ID = 'PASSPORT_ID';
export const CGV = 'CGV';
export const IDENTITY_NUMBER = 'IDENTITY_NUMBER';
export const PHONE_OPTIN = 'PHONE_OPTIN';
export const PROFILING = 'PROFILING';
export const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
export const PASSPORT_EXPIRATION_DATE = 'PASSPORT_EXPIRATION_DATE';
export const PASSPORT_ISSUING_DATE = 'PASSPORT_ISSUING_DATE';
export const NATIONALITY = 'NATIONALITY';
export const CLUBMED_PLUS = 'CLUBMED_PLUS';
